import React from 'react';

import MuiRadio, { RadioProps as MuiRadioProps } from '@material-ui/core/Radio';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';

export interface RadioProps extends MuiRadioProps {
  size?: 'small';
}

const Radio: React.FC<RadioProps> = ({ size, ...rest }) => (
  <MuiRadio
    icon={<RadioButtonUncheckedIcon fontSize="small" />}
    checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
    {...rest}
  />
);

export default Radio;
